import dafyaHomeDesktop from "../assets/images/portfolio/dafya/dafya-accueil-desktop.webp";
import dafyaHomeMobile from "../assets/images/portfolio/dafya/dafya-accueil-mobile.webp";
import dafyaAdminLogin from "../assets/images/portfolio/dafya/dafya-connexion-administration.webp";
import dafyaContactDesktop from "../assets/images/portfolio/dafya/dafya-contact-devis-desktop.webp";
import dafyaDashboardLight from "../assets/images/portfolio/dafya/dafya-tableau-de-bord-clair.webp";
import dafyaDashboardDark from "../assets/images/portfolio/dafya/dafya-tableau-de-bord-sombre.webp";
import relaxHomeDesktop from "../assets/images/portfolio/relax-time-massages/relax-time-massages-accueil-desktop.webp";
import relaxHomeMobile from "../assets/images/portfolio/relax-time-massages/relax-time-massages-accueil-mobile.webp";
import relaxContactBooking from "../assets/images/portfolio/relax-time-massages/relax-time-massages-contact-rendez-vous.webp";
import relaxServicesDesktop from "../assets/images/portfolio/relax-time-massages/relax-time-massages-services-desktop.webp";
import autoshineAdminDashboard from "../assets/images/portfolio/autoshine-essentials/autoshine-admin-dashboard.png";
import autoshineCatalogue from "../assets/images/portfolio/autoshine-essentials/autoshine-catalogue.png";
import autoshineGuides from "../assets/images/portfolio/autoshine-essentials/autoshine-guides.png";
import autoshineHomeDesktop from "../assets/images/portfolio/autoshine-essentials/autoshine-homepage-desktop.png";
import autoshineHomeMobile from "../assets/images/portfolio/autoshine-essentials/autoshine-homepage-mobile.png";
import autoshineProductFinder from "../assets/images/portfolio/autoshine-essentials/autoshine-product-finder.png";

const projects = [
  {
    slug: "dafya",
    name: "Dafya",
    type: "Projet client",
    shortDescription:
      "Site web et outil de gestion développés pour une activité de location d’assises et de mobilier événementiel.",
    detailDescription:
      "Création d’un site web sur mesure permettant de présenter l’activité de Dafya, ses offres et ses différentes ambiances, avec une gestion administrable du contenu.",
    context: [
      "Dafya propose un service de location d’assises et de mobilier événementiel autour de Bergerac, notamment pour les mariages, hennés, fiançailles et réceptions privées.",
      "Le projet consistait à construire une présence en ligne claire et élégante permettant de présenter l’activité, les offres et les différentes ambiances, tout en facilitant les demandes de contact et de devis.",
    ],
    intervention: [
      "Conception et développement du site web sur mesure",
      "Mise en place de l’architecture avec Symfony",
      "Développement de l’interface responsive avec Tailwind CSS",
      "Création et gestion des offres et des ambiances",
      "Mise en place du formulaire de contact et de demande de devis",
      "Développement d’un back-office pour administrer le contenu",
      "Mise en place de PostgreSQL et des migrations de base de données",
      "Conteneurisation et mise en production avec Docker et Nginx",
    ],
    cardTechnologies: ["Symfony", "PHP", "PostgreSQL", "Tailwind CSS", "Docker"],
    technologies: [
      "Symfony 7.4",
      "PHP 8.4",
      "PostgreSQL 16",
      "Tailwind CSS",
      "EasyAdmin",
      "Stimulus",
      "Turbo",
      "Docker",
      "Nginx",
    ],
    features: [
      "Présentation des offres et des ambiances",
      "Formulaire de contact et de demande de devis",
      "Back-office de gestion de contenu",
    ],
    url: "https://dafya.fr/",
    image: dafyaHomeDesktop,
    imageAlt: "Page d’accueil de Dafya sur ordinateur",
    screenshots: [
      {
        src: dafyaHomeDesktop,
        alt: "Page d’accueil de Dafya sur ordinateur",
      },
      {
        src: dafyaHomeMobile,
        alt: "Page d’accueil de Dafya sur mobile",
        variant: "mobile",
      },
      {
        src: dafyaContactDesktop,
        alt: "Page de contact et formulaire de demande de devis de Dafya",
      },
      {
        src: dafyaAdminLogin,
        alt: "Écran de connexion à l’administration de Dafya",
      },
      {
        src: dafyaDashboardLight,
        alt: "Tableau de bord d’administration de Dafya en thème clair",
      },
      {
        src: dafyaDashboardDark,
        alt: "Tableau de bord d’administration de Dafya en thème sombre",
      },
    ],
  },
  {
    slug: "autoshine-essentials",
    name: "AutoShine Essentials",
    type: "Projet complet",
    shortDescription:
      "Application e-commerce automobile full-stack proposant un catalogue de produits, des guides pratiques et un moteur de recommandation pour simplifier l’entretien automobile.",
    detailDescription:
      "Conception et développement d’une application e-commerce automobile complète, pensée pour accompagner les particuliers dans l’entretien courant de leur véhicule grâce à un catalogue, des guides pédagogiques et un moteur de recommandation.",
    context: [
      "AutoShine Essentials s’adresse aux particuliers qui souhaitent entretenir eux-mêmes leur voiture sans nécessairement maîtriser les techniques du detailing.",
      "L’objectif était de construire une expérience simple et pédagogique réunissant produits, conseils et recommandations, tout en développant l’ensemble de l’architecture technique nécessaire à une application moderne réellement déployée.",
    ],
    intervention: [
      "Conception de l’architecture full-stack avec Next.js / React / TypeScript et Symfony",
      "Développement d’un catalogue de 26 produits répartis dans 7 catégories",
      "Création des fiches produits, filtres et navigation par catégories",
      "Développement de guides d’entretien détaillés reliés aux produits",
      "Création d’un Product Finder recommandant des produits selon la zone et le besoin",
      "Conception de l’API REST Symfony et de la persistance avec Doctrine / PostgreSQL",
      "Développement du back-office avec EasyAdmin",
      "Travail approfondi sur le responsive mobile, l’accessibilité et la stabilité sur Safari/iPhone",
      "Mise en place des tests frontend/backend et de la CI GitLab",
      "Conteneurisation avec Docker et déploiement sur VPS avec Nginx",
      "Configuration HTTPS, gestion des secrets, sauvegardes PostgreSQL et procédures de maintenance",
    ],
    cardTechnologies: ["Next.js", "TypeScript", "Symfony", "PostgreSQL", "Docker"],
    technologies: [
      "Next.js 16",
      "React",
      "TypeScript",
      "Tailwind CSS",
      "Symfony 7.4",
      "PHP 8.3",
      "Doctrine ORM",
      "PostgreSQL 18",
      "EasyAdmin",
      "Docker",
      "Nginx",
      "GitLab CI/CD",
      "Vitest",
      "PHPUnit",
      "PHPStan",
      "Playwright",
    ],
    features: ["Catalogue de produits", "Guides d’entretien", "Product Finder"],
    url: "https://autoshineessentials.com",
    image: autoshineHomeDesktop,
    imageAlt: "Page d’accueil AutoShine Essentials",
    screenshots: [
      {
        src: autoshineCatalogue,
        alt: "Catalogue de produits AutoShine Essentials",
      },
      {
        src: autoshineGuides,
        alt: "Guides d’entretien automobile AutoShine Essentials",
      },
      {
        src: autoshineProductFinder,
        alt: "Moteur de recommandation de produits AutoShine Essentials",
      },
      {
        src: autoshineAdminDashboard,
        alt: "Tableau de bord d’administration AutoShine Essentials",
      },
      {
        src: autoshineHomeMobile,
        alt: "Page d’accueil mobile AutoShine Essentials",
        variant: "mobile",
      },
    ],
  },
  {
    slug: "relax-time-massages",
    name: "Relax Time Massages",
    type: "Projet client",
    shortDescription:
      "Site web sur mesure conçu pour une activité de bien-être, avec prise de rendez-vous, identité visuelle et accompagnement à la mise en ligne.",
    detailDescription:
      "Conception d’une présence web complète pour une activité de massage et de bien-être, de l’identité visuelle jusqu’au développement et au déploiement du site.",
    context: [
      "Création d’un site web sur mesure pour Relax Time Massages afin de présenter l’activité, les prestations et faciliter la prise de contact et de rendez-vous en ligne.",
      "L’interface a été pensée pour rester simple, rassurante et cohérente avec l’univers du bien-être.",
    ],
    intervention: [
      "Conception et développement du site web responsive",
      "Développement de l’interface avec React et Tailwind CSS",
      "Mise en place d’un formulaire de contact sécurisé",
      "Intégration d’un agenda en ligne pour la prise de rendez-vous",
      "Création de la charte graphique et du logo",
      "Optimisation de la visibilité et du référencement local",
      "Déploiement sur VPS avec Docker et Nginx",
      "Accompagnement du client dans la prise en main des outils numériques",
    ],
    cardTechnologies: ["React", "Node.js", "Tailwind CSS", "Docker", "Nginx"],
    technologies: ["React", "Node.js", "Tailwind CSS", "Docker", "Nginx"],
    features: ["Site web", "Formulaire de contact", "Agenda en ligne"],
    url: "https://relaxtimemassages.fr/",
    image: relaxHomeDesktop,
    imageAlt: "Page d’accueil de Relax Time Massages sur ordinateur",
    screenshots: [
      {
        src: relaxHomeDesktop,
        alt: "Page d’accueil de Relax Time Massages sur ordinateur",
      },
      {
        src: relaxServicesDesktop,
        alt: "Page des services et massages proposés par Relax Time Massages",
      },
      {
        src: relaxContactBooking,
        alt: "Page de contact et de prise de rendez-vous de Relax Time Massages",
      },
      {
        src: relaxHomeMobile,
        alt: "Page d’accueil de Relax Time Massages sur mobile",
        variant: "mobile",
      },
    ],
  },
];

export function getProjectBySlug(slug) {
  return projects.find((project) => project.slug === slug);
}

export default projects;
